import {
    BudgetCategoryGroupFieldsFragment,
    BudgetPurpose,
} from '../../graphql/generated';
import { CashflowTransactionEntry } from '../cashflow';
import { buildBudgetCategoryGroupMap } from './buildBudgetCategoryGroupMap';

export const filterTransactionEntriesForBudgetPurpose = ({
    budgetCategoryGroups,
    transactionEntries,
    budgetPurpose,
}: {
    budgetCategoryGroups: BudgetCategoryGroupFieldsFragment[];
    transactionEntries: CashflowTransactionEntry[];
    budgetPurpose: BudgetPurpose;
}) => {
    const budgetCategoryGroupMap =
        buildBudgetCategoryGroupMap(budgetCategoryGroups);

    return transactionEntries.filter((t) => {
        const budgetCategoryGroup =
            budgetCategoryGroupMap[t.category.categoryGroup.id];

        // If there's a budget category group, use its purpose
        // Otherwise fall back to the default purpose
        return budgetCategoryGroup
            ? budgetCategoryGroup.budgetPurpose === budgetPurpose
            : t.category.categoryGroup.defaultBudgetPurpose === budgetPurpose;
    });
};
